<template>
  <v-container>

    <v-row>
      <v-col md="12">
        <h1 class="font-weight-medium">

          <span v-if="$i18n.locale=='es'">{{evento.nombre_es}}</span>
           <span v-else>{{evento.nombre_ca}}</span>

          <span
            style="font-size:17px;color:#67833D">{{ $t('Inscripción') }}</span>
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="12">
        <h4 style="padding-left:20px;padding-top:0" class="font-weight-medium">
          {{ $t('Información del cava (s)participante (s)') }}</h4>
      </v-col>
    </v-row>
    <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
      <v-form ref="form">
        <v-container fill-height fluid>
          <v-row align="center">

            <v-col md="6" v-for="(data,index) in cavas" :key="data.id">
              <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <v-text-field
                        :label="$t('Nombre del Cava')"
                        filled
                        v-model="data.nombre"
                        maxlength="250"
                        :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>

                  <upload
                      :files="[data.foto]"
                      :multiple="false"
                      :title="$t('Foto del Cava')"
                      :validation="{required:true,size:5000,ext:['png','jpg','jpeg']}"
                      :hint="$t('Subir foto (jpg o png, max 2 MB)\n')"
                      :accept="'.png,.jpg,.jpeg'"
                      v-on:file-update="data.foto = $event"
                  ></upload>

                  <upload
                      :files="[data.ficha]"
                      :multiple="false"
                      :title="$t('Ficha técnica del Cava')"
                      :validation="{required:true,size:5000,ext:['pdf','zip']}"
                      :hint="$t('Subir pdf/zip max. 4mb')"
                      :accept="'.pdf,.zip'"
                      v-on:file-update="data.ficha = $event"
                  ></upload>

                  <upload
                      :files="[data.logo]"
                      :multiple="false"
                      :title="$t('Logotipo de la bodega')"
                      :validation="{required:false,size:5000,ext:['png','jpg','jpeg']}"
                      :hint="$t('Subir foto (jpg o png, max 2 MB)\n')"
                      :accept="'.png,.jpg,.jpeg '"
                      v-on:file-update="data.logo = $event"
                  ></upload>

                  <div style="display: none">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <v-select
                        v-model="data.num"
                        filled
                        :items="[0,1,2,3,4,5,6,7,8,9,10]"
                        :label="$t('Número de botellas enviadas')"
                        :error-messages="errors"
                    ></v-select>
                  </ValidationProvider>
                  </div>



                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <v-select
                        v-model="data.type_of_cava"
                        filled
                        :items="['Cava de Guarda','Cava de Guarda Superior Reserva','Cava de Guarda Superior Gran Reserva','Cava de Guarda Superior de Paraje Calificado','Cava Rosado']"
                        :label="$t('Tipo de Cava')"
                        :error-messages="errors"
                    ></v-select>
                  </ValidationProvider>


                      <ValidationProvider v-slot="{ errors }" rules="required">
                    <v-text-field
                        :label="$t('Precio')"
                        filled
                        v-model="data.price"
                        maxlength="250"
                        :error-messages="errors"
                        placeholder="Moneda local"
                    ></v-text-field>
                  </ValidationProvider>

                    <v-textarea
                        :label="$t('Comentarios')"
                        filled
                        v-model="data.comentario"
                        :counter="true"
                        maxlength="200"
                    ></v-textarea>

                  <div style="height: 30px;text-align: right">
              <v-btn v-if="index > 0" color="danger" dark @click="del(index)">
                {{ $t("Borrar Cava") }}
              </v-btn></div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col fill-height md="4" v-if="cavas.length < limite_cavas">

              <v-btn color="primary" dark @click="clone()">
                {{ $t("Añadir otro Cava") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </ValidationObserver>

    <v-row v-if="evento.region != 'España'">
      <v-col md="4">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <v-text-field
              :label="$t('Nombre del importador o responsable')"
              filled
              v-model="nombre"
              maxlength="250"
              :error-messages="errors"

          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col md="4">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <v-text-field
              :label="$t('Email del importador o responsable' )"
              filled
              v-model="email"
              maxlength="250"
              :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
            color="primary"
            dark
            @click="submit"
        >{{ $t('Enviar') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>

import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';
import Upload from "@/components/Upload";
import axios from "axios"

setInteractionMode('eager')


export default {
  components: {
    ValidationProvider, ValidationObserver, Upload
  },
  data() {
    return {
      evento:{},
      nombre: "-",
      email: "-",
      limite_cavas:1,
      ptype: {
        nombre: "",
        foto: [],
        ficha: [],
        logo: [],
        num: 0,
        price: "",
        type_of_cava:"",
        comentario:""
      },
      cavas: [
        {
          id: "",
          nombre: "",
          foto: [],
          ficha: [],
          logo: [],
          num: 1,
          price: "",
          type_of_cava:"",
          comentario:""
        }
      ]
    };
  },
  provide() {
    return {parentValidator: this.$validator}
  },
  computed: {},
  methods: {
    clone() {
      this.cavas.push(JSON.parse(JSON.stringify(this.ptype)))
    },
    del(index){
      //const index = this.cavas.indexOf(obj => obj.id == id)
      this.cavas.splice(index,1)
    },
    submit() {

      this.$refs.observer.validate().then(success => {

        if (!success) {
            const el = document.querySelector(".v-messages.error--text:first-of-type");
            el.scrollIntoView(true);
            window.scrollBy(0, -150);
            return;
        }

        //delete this.cavas[0].ficha
        this.cavas.forEach(function (v) {
          delete v.ficha.id
        });
        this.cavas.forEach(function (v) {
          delete v.foto.id
        });
        this.cavas.forEach(function (v) {
          delete v.logo.id

          try {
            if (v.logo.length == 0){
              v.logo = null
            }
          }
          catch (e){
            console.log('empty')
          }

        });


        const config = {
          // or delete person["age"];

          method: "patch",
          url: this.$store.state.endpoints.participacion + this.id + "/",
          headers: {Authorization: "Bearer " + this.$store.state.jwt},
          data: {
            ok: true,
            nombre: this.nombre?this.nombre:'-',
            email: this.email?this.email:'-',
            cavas: this.cavas
          }
        };

        axios(config)
            .then((response) => {
              this.$router.push({name: 'eventosedit', params: {id: this.id}})
              this.$store.commit("showMessage",{color:"green",content:this.$i18n.t("Guardado")})

            })
            .catch(error => {
              console.log(error)
            });
      })
    }
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      const config = {
        headers: {Authorization: "Bearer " + this.$store.state.jwt},
      };
      axios.get(this.$store.state.endpoints.participacion + this.id+"/", config)
          .then((response) => {
            //this.nombre = response.data.evento.nombre
            this.evento = response.data.evento
            this.nombre = response.data.nombre
            this.email = response.data.email


            this.limite_cavas = response.data.evento.limite_cavas
            this.showimportador = response.data.evento.regions

            try{
              if(this.evento.bodega.user != this.$store.state.userid){
                this.$router.push('/');
              }
            }
            catch (e) {
              console.log(e)
            }

            if (response.data.cavas.length > 0) {
              this.cavas = response.data.cavas
              this.cavas.forEach((o,i) => {
                if(o.logo === null){
                  o.logo = []
                }
              })
            }
          })
          .catch(error => {
            console.log(error)
          });
    }
  }

};
</script>





